<template>
    <div class="table-responsive mb-4">
        <table class="table table-bordered">
            <thead>
            <tr>
                <th>Product</th>
                <th class="text-end">P. Rate</th>
                <th class="text-end">Qty</th>
                <th class="text-end">Amount</th>
                <th class="text-center">Action</th>
            </tr>
            </thead>

            <tbody v-if="isArray(itemDetails) && itemDetails.length">
            <tr v-for="(item, index) in itemDetails" :key="index">
                <td>{{ item.product_name }}</td>

                <td class="text-end p-0" style="width:120px;" @click="startEdit(index, 'rate')">
                    <input
                        v-if="editingCell.index === index && editingCell.field === 'rate'"
                        type="number"
                        class="inline-cell-input"
                        v-model.number="item.rate"
                        @blur="stopEdit"
                        @keyup.enter="stopEdit"
                        @keyup.escape="stopEdit"
                        v-focus
                    />
                    <span v-else class="d-block px-2 py-1">{{ item.rate }}</span>
                </td>

                <td class="text-end p-0" style="width:100px;" @click="startEdit(index, 'quantity')">
                    <input
                        v-if="editingCell.index === index && editingCell.field === 'quantity'"
                        type="number"
                        class="inline-cell-input"
                        v-model.number="item.quantity"
                        @blur="stopEdit"
                        @keyup.enter="stopEdit"
                        @keyup.escape="stopEdit"
                        v-focus
                    />
                    <span v-else class="d-block px-2 py-1">{{ item.quantity }}</span>
                </td>

                <td class="text-end">{{ (item.rate * item.quantity).toFixed(2) }}</td>

                <td class="text-center">
                    <button
                        class="btn btn-sm btn-danger"
                        @click="$emit('removeBill', index)"
                    >
                        <i class="fa fa-trash"></i>
                    </button>
                </td>
            </tr>
            </tbody>

            <tbody v-else>
            <tr>
                <td colspan="5" class="text-center text-muted">
                    No items added
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { isArray } from "lodash";

const props = defineProps({
    itemDetails: {
        type: Array,
        default: () => []
    },
});

defineEmits(['removeBill']);

const editingCell = ref({ index: null, field: null });

const startEdit = (index, field) => {
    editingCell.value = { index, field };
};

const stopEdit = () => {
    editingCell.value = { index: null, field: null };
};

const vFocus = {
    mounted(el) { el.focus(); el.select(); }
};
</script>

<style scoped>
.inline-cell-input {
    width: 100%;
    text-align: right;
    padding: 4px 6px;
    box-sizing: border-box;
    background: #fff;
    border: 1px solid #86b7fe;
    border-radius: 3px;
    outline: none;
}
</style>
